// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { APPMODE } from './appmode.enum';
import { environmentBase } from './environment.base';

// tslint:disable
export const environment = {
  ...environmentBase,
  googleClientId: window['env'].googleClientId,
  appleClientId: window['env'].appleClientId,
  mode: APPMODE.Web,
};
// tslint:enable

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
